<template>
    <div class="column is-one-third">
        <div class="card">
            <div class="card-image">
                <figure class="image is-4by3">
                    <img v-bind:src="'https://farm' + image.farm + '.staticflickr.com/' + image.server + '/' + image.id + '_' + image.secret + '_z.jpg'">
                </figure>
            </div>
            <footer class="card-footer">
                <a class="card-footer-item" v-bind:href="image.url_o" download>Original</a>
                <a class="card-footer-item" v-bind:href="'https://farm' + image.farm + '.staticflickr.com/' + image.server + '/' + image.id + '_' + image.secret + '_h.jpg'" download>Medium</a>
                <a class="card-footer-item" v-bind:href="'https://farm' + image.farm + '.staticflickr.com/' + image.server + '/' + image.id + '_' + image.secret + '_q.jpg'" download>150 x 150</a>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
  name: 'FlickrCard',
  props: [ 'image' ]
}
</script>
